var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vn-select-add',{staticClass:"parameter-select",attrs:{"label":_vm.prop.name,"value":_vm.value || _vm.placeholderValue,"options":_vm.availableFontStyles,"no-clear":"","no-remove-option":""},on:{"input":function($event){return _vm.updateProp($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }